<template>
  <div :class="$style.sound">
    <div
      :class="[
        $style['sound__wave'],
        audioPlay ? $style['sound__wave--play'] : $style['sound__wave--paused'],
      ]"
      @click="toggleAudio()"
    >
      <canvas ref="canvas" />
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import { Howler } from 'howler';
import AudioLine from '@/scripts/AudioLine';
import loop from '@/scripts/loop';

export default {
  name: 'sound',

  props: {
    sound: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      audioPlay: true,
      line: null,
    };
  },

  mounted() {
    this.initLine();
  },

  methods: {
    toggleAudio() {
      this.audioPlay = !this.audioPlay;

      if (this.audioPlay) {
        Howler.mute(false);
        gsap.to(this.line, 0.3, {
          speed: 1,
          color: '#0072CE',
        });
      } else {
        Howler.mute(true);
        gsap.to(this.line, 0.3, {
          speed: 0,
          color: '#3C3C40',
        });
      }
    },

    initLine() {
      this.line = new AudioLine(this.$refs.canvas);
      this.line.init();

      loop.add(this.render, 'audioLine-render');
    },

    render() {
      this.line.render();
    },
  },
};
</script>

<style lang="scss" module>
.sound {
  overflow: hidden;
  width: 80px;
  padding: 20px 0;

  cursor: pointer;

  .sound__wave {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sound__wave,
  canvas {
    position: relative;
    width: 80px;
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sound.vue